<template>
  <b-row :class="[stateClass, sizeClass]">
    <b-col>
      <b-list-group class="list-municipios">
        <b-list-group-item
          v-if="!value.length"
          class="d-flex list-municipios-item"
        >
          {{ placeholder }}
        </b-list-group-item>

        <b-list-group-item
          v-for="(municipio, key) in value"
          :key="key"
          class="d-flex list-municipios-item"
        >
          {{ municipio.estado_sigla }} /
          {{ municipio.nome }}

          <b-button
            @click="removeMunicipio(key)"
            variant="outline-danger"
            class="ml-auto"
          >
            <font-awesome-icon icon="far fa-trash-alt" />
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <b-col>
      <VueTypeaheadBootstrap
        v-model="search_state"
        @hit="selectEstado"
        :data="estados"
        :serializer="(item) => item.nome + ' - ' + item.sigla"
        placeholder="Buscar estados..."
        :class="[stateClass]"
        :showOnFocus="true"
        :size="size"
        :disabled="disabled"
      />
      <!-- {{ item }} -->
    </b-col>
    <b-col>
      <VueTypeaheadBootstrap
        v-model="search"
        :data="municipios"
        :serializer="(item) => item.estado_sigla + ' / ' + item.nome"
        placeholder="Buscar municípios..."
        @input="findMunicipio"
        @hit="addMunicipio"
        class="form-control form-control-custom"
        :size="size"
        :disabled="disabled || waiting_state"
      />
    </b-col>
  </b-row>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";
import { debounce, find } from "lodash";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {
      type: Array,
      default: [],
    },
    placeholder: {
      type: String,
      default: "Nenhum município selecionado",
    },
    uf: {
      type: String,
      default: null,
    },
    return_object: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    municipios: [],
    estados: [],
    search_state: "",
    estado_sigla: null,
    waiting_state: true,
  }),
  computed: {
    sizeClass() {
      return "form-control-" + this.size;
    },
  },
  async created() {
    this.estados = await this.ActionGetAllEstados();
  },
  methods: {
    ...mapActions("municipios", [
      "ActionFind",
      "ActionFindById",
      "ActionGetAllEstados",
    ]),
    findMunicipio: debounce(async function () {
      let payload = { q: this.search, estado_sigla: this.estado_sigla };
      if (this.uf) {
        payload.estado_sigla = this.uf;
      }
      var municipios = await this.ActionFind(payload);
      this.municipios = municipios.data;
    }, 500),
    addMunicipio(municipio) {
      if (municipio) {
        this.search = "";
        this.search_state = "";
        this.municipios = [];
        let has_mun = find(this.value, ["id", municipio.id]);
        if (!has_mun) {
          this.value.push(municipio);
          this.waiting_state = true;
          this.estado_sigla = null;
          this.$emit("input", this.value);
        } else {
          this.$notifications.addNotification({
            message: "Este município ja foi selecionado",
            icon: "exclamation-triangle",
            type: "warning",
          });
        }
      }
    },
    selectEstado(state) {
      this.waiting_state = false;
      this.estado_sigla = state.sigla;
    },
    removeMunicipio(index) {
      this.value.splice(index, 1);
      this.$emit("input", this.value);
    },
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-top: 0 !important;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}

.list-municipios {
  .list-municipios-item {
    padding: 0.5rem !important;
    line-height: 30px;

    &:hover {
      .btn {
        opacity: 1;
      }
    }
  }

  .btn {
    opacity: 0;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0 !important;

    font-size: 1rem;
    padding: auto !important;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s !important;
  }
}
</style>
